// Lógica de búsqueda por texto del sistema (la usan SearchSelect y ClienteSelect).

// Marcas de acento que quedan sueltas al descomponer con NFD (tilde, diéresis, etc.).
// Se construye con RegExp para que los escapes \u no dependan del encoding del archivo.
const ACENTOS = new RegExp('[\\u0300-\\u036f]', 'g');

// Normaliza: minúsculas, sin acentos, espacios colapsados.
// Así "Chávez" se encuentra escribiendo "chavez" y "Muñoz" escribiendo "munoz".
export const normalizarTexto = (s) => String(s ?? '')
  .normalize('NFD')
  .replace(ACENTOS, '')
  .toLowerCase()
  .replace(/\s+/g, ' ')
  .trim();

// Coincide si CADA palabra de la consulta aparece en el texto, en cualquier orden
// y sin importar qué haya entre ellas. Pensado para nombres completos:
// "Ricardo Griffith" encuentra a "Ricardo Antonio Griffith Chávez".
export function coincideBusqueda(texto, consulta) {
  const q = normalizarTexto(consulta);
  if (!q) return true;
  const hay = normalizarTexto(texto);
  return q.split(' ').every(palabra => hay.includes(palabra));
}
